import routeName from '@/router/constant';
import store from '@/store';

/**
 * @param {String} from 要加入的變更項目代碼
 * @param {Array} whiteList 來源的白名單
 * @param {Boolean} isReload 可否接受來源是根目錄
 * @param {String|Array|undefined} aplCatl 可以進入該頁面的aplCatl號碼
 */
export const guideRoutes = (from, whiteList, isReload, aplCatl) => {
    let mappingAplCatl = false;
    if (!aplCatl) {
        mappingAplCatl = true;
    } else if (typeof aplCatl === 'string') {
        mappingAplCatl = store.state.services.aplCatl === aplCatl;
    } else {
        mappingAplCatl = aplCatl.includes(store.state.services.aplCatl);
    }
    if (mappingAplCatl) {
        if (isReload && from.fullPath === '/') return true;
        if (whiteList.findIndex(i => i === from.name) > -1) return true;
        if (store.state.permissions.userInfo.system === 'CEC') {
            return { name: routeName.CLOUD_E_COUNTER_RESERVE_HOME };
        } else {
            return { name: routeName.HOME };
        }
    } else {
        if (store.state.permissions.userInfo.system === 'CEC') {
            return { name: routeName.CLOUD_E_COUNTER_RESERVE_HOME };
        } else {
            return { name: routeName.HOME };
        }
    }
};
